import { Badge, IconButton } from '@taleemabad/dsm/components';
import styled from '@emotion/styled';

export interface NotificationBadgeProps {
  count: number;
  onClick: () => void;
}
export const NotificationBadge = ({
  count,
  onClick,
}: NotificationBadgeProps) => {
  return (
    <StyledNotificationBadgeWrapper>
      {count > 0 && (
        <StyledBadgeWrapper>
          <Badge
            type="filled"
            size="small"
            label={count.toString()}
            color="var(--md-sys-color-schemes-error)"
          />
        </StyledBadgeWrapper>
      )}
      <IconButton
        icon={'notifications'}
        color="var(--md-sys-color-on-surface)"
        onClick={onClick}
      />
    </StyledNotificationBadgeWrapper>
  );
};

const StyledBadgeWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
`;

const StyledNotificationBadgeWrapper = styled.div`
  position: relative;
  width: fit-content;
`;
